
const projectGroupMoudle={
  namespaced: true,
  state:{
    groupName:'',
  },
  mutations:{

  },
  getters:{

  },
  actions:{

  }
};

export default projectGroupMoudle;



// WEBPACK FOOTER //
// ./src/store/moudles/projectGroup.js